var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.menu.children
        ? _c(
            "el-submenu",
            { attrs: { index: _vm.menu.url } },
            [
              _c("template", { slot: "title" }, [
                _c("i", { class: _vm.menu.icon }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.menu.name))])
              ]),
              _vm._v(" "),
              _vm._l(_vm.menu.children, function(item, index) {
                return _c("nav-menu", { key: index, attrs: { menu: item } })
              })
            ],
            2
          )
        : _c("el-menu-item", { attrs: { index: _vm.menu.url } }, [
            _c("i", { class: _vm.menu.icon }),
            _vm._v(" "),
            _c("span", { attrs: { slot: "title" }, slot: "title" }, [
              _vm._v(_vm._s(_vm.menu.name))
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a380d422", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a380d422","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = null
// module chunks = 